/*
* Created on Mar 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useState} from 'react';
import chara_120_svg from '../../../static/img/temp/chara_120x120.png';
// import GoogleContacts from 'react-google-contacts';
import useToggle from "../../../hook/ToggleHook";
import {useQuery} from "@tanstack/react-query";
import {CONTACT_TYPE_MAP} from "../../../service/common";
// import GoogleLogin from 'react-google-login';
import axios from "axios";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";


const ContactListInputComponent = ({showContact, setShowContact, input, setInput, validate}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const [googleContacts, setGoogleContacts] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const googleServiceCallback = (resp) => {
        console.log(resp);
        console.log(resp.accessToken);
        if (googleContacts.length <= 0) {
            console.log('Google User Signed In ? ' + resp.isSignedIn());
            axios.get('https://people.googleapis.com/v1/people:listDirectoryPeople', {
                params: {
                    access_token: resp.accessToken,
                    readMask: 'names,emailAddresses',
                    sources: 'DIRECTORY_SOURCE_TYPE_DOMAIN_PROFILE',
                    pageSize: 1000
                }
            }).then((data)=>{
                console.log(data);
                const people = data?.data?.people || [];
                const glist = people.map((c) => {
                    const primaryName = c.names?.filter(n=>n.metadata.primary);
                    const primaryEmail = c.emailAddresses.filter(e=>e.metadata.primary);
                    return {
                        name: primaryName?.[0]?.displayName || primaryEmail?.[0]?.value,
                        email: primaryEmail?.[0]?.value
                    }})
                console.log(glist)
                setGoogleContacts(glist);
            })
        }
    }

    const {data:friends} = useQuery({
        queryKey: [`get_qnap_friend_list`],
        queryFn: async () => {
            const group_list = await OrganizationAPI.friend.get(``, {limit: 200});
            // setGroups(group_list.result);
            return group_list.result;
        }
    });

    const [open, node] = useToggle();
    const [contactType, setContactType] = useState('myqnapcloud');

    const switchContact = (type, callback) => {
        if (type === 'google' && googleContacts.length <= 0) {
            callback();
        }
        setContactType(type);
    }

    const onSelectEmail = (email, name) => {
        let err = null;
        if (validate) {
            err = validate({target: {value: email}})
        }
        setInput((prevInput)=>{return {...prevInput, qid: {...prevInput.qid, value: email, error: err}, name}})
        setShowContact(false);
    }


    return (
        <div className={`comp-dropdown ${showContact ? '' : 'hide'}`}>
            <ul className="comp-dropdown-menu">
                <li className="section func-section">
                    <div className="heading">
                        <div className="title">{t('@Contact List@')}</div>
                        <div className="close" onClick={()=>setShowContact(false)}/>
                    </div>
                    <div className="con">
                        <div className="comp-select" ref={node}>
                            <div className="select-toggle">
                                <span className="select-label">{CONTACT_TYPE_MAP[`${contactType}`]}</span>
                            </div>
                            {/*<div className={`comp-dropdown ${open==='show' ? '' : 'hide'}`}>*/}
                            {/*    <ul className="comp-dropdown-menu">*/}
                            {/*        <li className="section">*/}
                            {/*            <div className="section-items selection" onClick={()=>switchContact('myqnapcloud')}>myQNAPcloud</div>*/}
                            {/*            <GoogleLogin onSuccess={googleServiceCallback}*/}
                            {/*                         onFailure={googleServiceCallback}*/}
                            {/*                         clientId={window._env_.REACT_APP_GOOGLE_CLIENT_ID}*/}
                            {/*                         scope={'https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/directory.readonly'}*/}
                            {/*                         render={(a)=>(*/}
                            {/*                             <div className="section-items selection" onClick={()=>switchContact('google', a.onClick)}>Google</div>*/}
                            {/*                         )}*/}
                            {/*                         isSignedIn={true}>*/}
                            {/*            </GoogleLogin>*/}
                            {/*        </li>*/}
                            {/*    </ul>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </li>
                <li className="section func-section contacts-filter">
                    <div className="filter-bar">
                        <input type="text" placeholder={t('@Search@')} onChange={(e)=>setSearchQuery(e.target.value)}/>
                    </div>
                </li>
                <li className="section add-scroll">
                    {contactType === 'myqnapcloud' && (
                        friends?.filter((f)=>f.email).filter((f)=>f.email.match(new RegExp(searchQuery, 'i')) || f.nickname?.match(new RegExp(searchQuery, 'i'))).map((f, index)=>{
                            return (
                                <div className="section-items selection" key={`f-${index}`} onClick={()=>onSelectEmail(f.email, f.nickname)}>
                                    <div className="contact-info">
                                        <div className="account-img">
                                            <div className={`avatar ${f.avatars?.small ? '' : 'no-avatar'}`}>
                                                {f.avatars?.small && <img src={f.avatars.small} alt={''}/>}
                                                {!f.avatars && <span>{f.nickname?.[0] || f.email[0]}</span>}
                                            </div>
                                        </div>
                                        <div className="account-info">
                                            <div className="name">{f.nickname}</div>
                                            <div className="mail">{f.email}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}

                    {contactType === 'google' && (
                        googleContacts?.filter((f)=>f.email.match(new RegExp(searchQuery, 'i')) || f.name.match(new RegExp(searchQuery, 'i'))).map((f, index)=>{
                            return (
                                <div className="section-items selection" key={`g-${index}`} onClick={()=>onSelectEmail(f.email, f.name)}>
                                    <div className="contact-info">
                                        <div className="account-img">
                                            <div className="avatar no-avatar"><span>{f.email[0]}</span></div>
                                        </div>
                                        <div className="account-info">
                                            <div className="name">{f.name}</div>
                                            <div className="mail">{f.email}</div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}
                </li>
            </ul>
        </div>
    );
};

export default ContactListInputComponent;